export const LIST_PAGE_NAME = 'VIDEOS';